"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("@/components/Button"));
const style_1 = require("./style");
function AccountMenu({ label, options }) {
    const [isMenuShown, toggleMenu] = (0, react_1.useState)(false);
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const onToggleMenu = (0, react_1.useCallback)((event) => {
        toggleMenu(!isMenuShown);
        setAnchorEl(event.currentTarget);
    }, [isMenuShown]);
    return (react_1.default.createElement(style_1.AccountMenuWrapper, null,
        react_1.default.createElement(Button_1.default, { size: "medium", variant: "outlined", color: "secondary", label: label, onClick: onToggleMenu, rightLabel: fa_1.FaChevronDown, rightLabelSize: 16 }),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, open: isMenuShown, onClick: onToggleMenu, anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: { vertical: "top", horizontal: "right" } }, options.map((option) => {
            return (react_1.default.createElement(MenuItem_1.default, { onClick: option.onClick, key: option.label }, option.label));
        })),
        !isMenuShown && null));
}
exports.default = AccountMenu;
